import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../../Services/Api/ApiServices";

export const GetAllFields = createAsyncThunk(
  "DropDowns/GetAllFields",
  async (applicationInformationId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post("api/DropDowns/GetAllFields", {
        applicationInformationId: applicationInformationId,
      });

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const DropDownFields = createSlice({
  name: "DropDownFieldsManager",
  initialState: {
    DropDownFields: [],
    loadingDropDownFields: false,
    errorDropDownFields: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAllFields.pending, (state, action) => {
        state.loadingDropDownFields = true;
        state.DropDownFields = action.payload;
        state.errorDropDownFields = null;
      })
      .addCase(GetAllFields.fulfilled, (state, action) => {
        state.loadingDropDownFields = false;
        state.DropDownFields = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAllFields.rejected, (state, action) => {
        state.loadingDropDownFields = false;
        state.errorDropDownFields = action.payload;
      });
  },
});

export default DropDownFields.reducer;
